import React from "react";
import WithdrawNew from "../../Component/WalletPage/WithdrawNew";

function WithdrawPage() {
    return (
        <div className="container-xxl">
            <WithdrawNew />
        </div>
    );
}

export default WithdrawPage;
